import { RESIZE_SUFFIX_REG, WEBP_SUFFIX_REG, DUPLICATED_SUFFIX_REG, SVG_SUFFIX_REG, FILE_EXT_REG } from '../config';
function getUrlParams(url) {
  var regResult = RESIZE_SUFFIX_REG.exec(url);
  var params = regResult ? {
    size: regResult[1],
    quality: regResult[4],
    sharpen: regResult[5]
  } : {};
  return params;
}
function getIccProfile(urlStr, params) {
  var newUrlStr = urlStr + '?icc=1';
  if (params.quality) {
    var oldQualityNum = +params.quality.replace('q', '');
    if (oldQualityNum && (!params.format || !~['avif', 'webp'].indexOf(params.format))) {
      var newQuality = "q" + Math.ceil(oldQualityNum / 2);
      newUrlStr = newUrlStr.replace(params.quality, newQuality);
    }
  }
  return newUrlStr;
}

/**
 * get ext from ext
 * url may do not have ext
 * @param {sting} url
 */
export function getFileExt(url) {
  var extResult = FILE_EXT_REG.exec(url);
  if (extResult && extResult[1]) {
    return extResult[1];
  }
  return '';
}

/**
 * get the url without resize suffix
 * @param {sting} url
 */
function getOriginalUrl(url) {
  return url.replace(RESIZE_SUFFIX_REG, '').replace(WEBP_SUFFIX_REG, '').replace(DUPLICATED_SUFFIX_REG, '$1');
}

/**
 * compose final url for image.
 * @param  {object} params
 */
function composeUrlString(url, params) {
  var sourceUrl = getOriginalUrl(url);
  var jpgStr = '';
  var formatStr = '';
  if (params.size) {
    jpgStr += params.size;
  }
  if (params.quality) {
    jpgStr += params.quality;
  }
  if (params.sharpen) {
    jpgStr += params.sharpen;
  }
  if (jpgStr) {
    if (params.format && params.format !== 'webp') {
      jpgStr = "_" + jpgStr + "." + params.format;
    } else if (SVG_SUFFIX_REG.test(sourceUrl)) {
      jpgStr = "_" + jpgStr + ".gif";
    } else if (params.alpha) {
      var ext = getFileExt(sourceUrl) || 'png';
      var targetExt = ext === 'png' ? 'png' : 'jpg';
      jpgStr = "_" + jpgStr + "." + targetExt;
    } else {
      jpgStr = "_" + jpgStr + ".jpg";
    }
  }
  if (params.format && params.format === 'webp') {
    formatStr = "_." + params.format;
  }
  return sourceUrl + getIccProfile(jpgStr + formatStr, params);
}

/**
 * get the url with suffix
 * @param {string} src
 * @param {object} params
 */
export default function getUrl(url, params) {
  var urlParams = params.clean ? {} : getUrlParams(url);
  params = Object.assign({}, urlParams, params);
  return composeUrlString(url, params);
}